import {customAxios} from '../../../../../infrastructure/api/CustomAxios';
import {Endpoints} from '../../../../../config/Endpoints';

export const DeleteProfileResource = {
  delete: () => {
    return customAxios.delete(Endpoints.profile.me);
  },
};
